import { render, staticRenderFns } from "./indexOrderAD_editor.vue?vue&type=template&id=ba723668"
import script from "./indexOrderAD_editor.vue?vue&type=script&lang=js"
export * from "./indexOrderAD_editor.vue?vue&type=script&lang=js"
import style0 from "./indexOrderAD_editor.vue?vue&type=style&index=0&id=ba723668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports